import BlogArticles from "./BlogArticles";
import mapProps from "recompose/mapProps";

const enhance = mapProps((props) => ({
  ...props.primary,
  items: props.items,
}));

export default enhance(BlogArticles);
